module.exports = __webpack_public_path__ + "media/assets/images/empty_chat_notification-8fbd96159ca5f897c966d6445a407002.svg";